import list from './list'

const courses =
{
    ...list,
    helmet :
    {
        title : 'Parcours' ,
        metas : []
    },
    empty  : 'Aucun parcours trouvé',
    search : 'Rechercher un parcours ...' ,
    title  : 'Parcours'
};

export default courses ;
